import { useState } from "react";
import { apiFetch } from '@/lib/api';
import { FiX } from "react-icons/fi";
import ScriptEditor from "../ScriptEditor";
import ScriptHistory from "../ScriptHistory";
import Button from "../ui/Button";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../ui/shadcn/tabs";
import { useShow } from "@/contexts/ShowContext";
import { useEpisode } from "@/contexts/EpisodeContext";

export default function ScriptEditorModal({script, onClose, onSaveScript, onRefreshScript}) {
    const { show } = useShow()
    const { episode, updateScript } = useEpisode()
    const [editedScript, setEditedScript] = useState(script || {})
    const [activeTab, setActiveTab] = useState('editor')

    const saveScript = async (scriptObj, data, debounce) => {
        if (onSaveScript) {
            await onSaveScript(scriptObj, data)
        } else {
            updateScript(scriptObj, data, debounce)
        }
    }

    const handleSelectHistory = async (history) => {
        try {
            const createResponse = await apiFetch(`/api/shows/${show._id}/episodes/${episode._id}/history`, {
                method: 'POST',
                body: JSON.stringify(editedScript)
            })
            if (!createResponse.ok) throw new Error('Failed to save current to history')

            const deleteResponse = await apiFetch(`/api/shows/${show._id}/episodes/${episode._id}/history/${history._id}`, {
                method: 'DELETE'
            })
            if (!deleteResponse.ok) throw new Error('Failed to delete history entry')

            await saveScript(editedScript, {
                speech: history.tts_speech,
                tts_speech: history.tts_speech,
                tts_character: history.tts_character,
                audio_url: history.audio_url,
                audio_key: history.audio_key,
                audio_duration: history.audio_duration,
                character: history.character
            }, false)
        } catch (error) {
            console.error(error)
        }

        setActiveTab('editor')
    }

    return (
        <div className='w-full h-full max-w-[500px] flex flex-col bg-background border-l gap-2'>
            <div className='flex justify-between py-2 px-4 items-center '>
                <span className='text-white text-lg font-bold'>Script</span>
                <div className='cursor-pointer text-gray-400 hover:text-white' onClick={() => onClose(null)}><FiX className="w-6 h-6" /></div>
            </div>
            <Tabs value={activeTab} onValueChange={setActiveTab} className='flex flex-col flex-1 overflow-hidden'>
                <TabsList className='w-full rounded-none'>
                    <TabsTrigger value='editor'>Script Editor</TabsTrigger>
                    <TabsTrigger value='history'>Script History</TabsTrigger>
                </TabsList>

                <TabsContent value='editor' className='flex-1 overflow-hidden'>
                    <ScriptEditor defaultValue={editedScript} onChange={(updated) => setEditedScript(updated)} onSaveScript={onSaveScript} onRefreshScript={onRefreshScript} />
                </TabsContent>
                <TabsContent value='history' className='flex-1 overflow-hidden'>
                    <ScriptHistory onSelect={handleSelectHistory} script={script} showHeader={false} />
                </TabsContent>
            </Tabs>
            <div className='flex py-2 px-4 gap-4'>
                <Button type='primary' className='min-w-20' onClick={() => onClose(null)}>Done</Button>
            </div>
        </div>
    )
}
